import React from "react";
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';

import { loginUser, getCurrentUser, loginFBUser } from '../../actions/session';
import { whereBallsMove } from "../../helper";
import { getClientId, getClientSecret } from "../Commons/Constants";
import imageVk from '../../images/vk-social.svg';
import imageGoogle from '../../images/gl-logo2.png';
import FacebookLogin from 'react-facebook-login';
// import GoogleLogin from 'react-google-login';

class SignIn extends React.Component {

    componentWillMount() {
        const { hash } = this.props.location;

        const hash_params = new URLSearchParams(hash);
        const access_token_vk = hash_params.get('#access_token');
        localStorage.setItem('access_token', access_token_vk);

        window.history.pushState(null, null, "/signin");

        if(access_token_vk){
            this.socialLogin('vk-oauth2', access_token_vk, () => {
            });
        }
    }

    componentDidMount() {
        document.title = 'Fixfact';
        whereBallsMove(4);
    }

    handleSubmit(e) {
        e.preventDefault();

        const { dispatch, history } = this.props;
        let code = localStorage.getItem('invite_code');
        let redirectPage = (code) ? `/invite/${code}` : '/';

        dispatch(
            loginUser({
                username: this.refs.username.value,
                password: this.refs.password.value
            },
                () => history.push(redirectPage, ""),
                (token) => dispatch(getCurrentUser(token))
            )
        )
    }

    socialLogin(type, token, callback) {
        const { dispatch, history } = this.props;
        let formData = new FormData();
        formData.append('grant_type', 'convert_token');
        formData.append('client_id', getClientId(type));
        formData.append('client_secret', getClientSecret(type));
        formData.append('backend', type);
        formData.append('token', token);

        if(callback) callback();

        dispatch(
            loginFBUser(
                formData,
                () => history.push("/", "home"),
                (token) => dispatch(getCurrentUser(token))
            )
        )
    }

    handleVK() {
        let URL = "https://oauth.vk.com/authorize?client_id=6375392&display=page&redirect_uri=http://fixfact.ru/signin&scope=photos,group,offline,wall,notify,email&response_type=token&v=5.74";

        window.location.replace(URL);
    }

    responseFacebook(response) {
        if (response) {
            this.socialLogin('facebook', response.accessToken);
        }
    }

    responseGoogle(response) {
        if (response.accessToken) {
            this.socialLogin('google-oauth2', response.accessToken);
        }
    }

    render() {

        const { errorMessage, isFetching } = this.props;

        return (
            <div className="vertical-scrolling page fifthSection sectionSignUp" id="sectionSignUp" data-main-nav-id="signUpNavLink">
                <div className="container content login-content">

                    <div className="left-content left-content-width" style={{ justifyContent: "start" }}>
                        <div className="login-top">
                            <h2 className="login__title">Авторизация</h2>
                        </div>
                    </div>

                    <div className="right-content native-scroll right-content-bottom right-content-width">
                        <div className="screen-outer-block-wrap native-scroll menu-content">
                            <div className="menu-content-individual menu-content-item tab-parent screen-bottom-block">
                                <div className="rounded-white-block">
                                    <div className="white-block-content">
                                        <div className="sign-up-form-wrap">
                                            <form onSubmit={this.handleSubmit.bind(this)}>
                                                <input ref="username" type="text" placeholder="Логин (почта)" className="width100" />
                                                {
                                                    errorMessage && errorMessage.username
                                                        ? errorMessage.username.map((text, index) =>
                                                            <span key={index} className="input-error-text">{text}</span>
                                                        )
                                                        : ''
                                                }
                                                <input ref="password" type="password" placeholder="Пароль" className="width100" />
                                                {/* <input ref="btb" type="text" placeholder="btn" className="width100"/> */}
                                                {
                                                    errorMessage && errorMessage.password
                                                        ? errorMessage.password.map((text, index) =>
                                                            <span key={index} className="input-error-text">{text}</span>
                                                        )
                                                        : ''
                                                }
                                                {
                                                    errorMessage && errorMessage.non_field_errors
                                                        ? errorMessage.non_field_errors.map((text, index) =>
                                                            <span key={index} className="input-error-text">{text}</span>
                                                        )
                                                        : ''
                                                }
                                                <div className="big-button button-action width100">
                                                    <button className={isFetching ? 'disabled' : ''}>Войти</button>
                                                </div>

                                                <div style={{ marginTop: '25px', alignItems: 'center', justifyContent: 'space-between', display: 'flex' }}>
                                                    <div style={{ display: 'flex' }}>
                                                        <FacebookLogin
                                                            appId="202889673626661"
                                                            autoLoad={false}
                                                            isDisabled={isFetching ? true : false}
                                                            fields={['email']}
                                                            scope={['email']}
                                                            callback={(response) => this.responseFacebook(response)}
                                                            textButton=''
                                                            cssClass="test-fb-button"
                                                            icon="fa-facebook"
                                                        />
                                                        {/* <GoogleLogin
                                                            clientId={`491145896490-t5i7j0sd5f31pacm0k9sehlljb0o5vq7.apps.googleusercontent.com`}
                                                            buttonText=''
                                                            autoLoad={false}
                                                            disabled={isFetching ? true : false}
                                                            redirectUri='https://fixfact.ru'
                                                            style={{width: '30px', height: '30px', border: 'none', padding: 0, marginRight: '10px', backgroundColor: 'transparent'}}
                                                            onSuccess={response => this.responseGoogle(response)}
                                                            onFailure={response => this.responseGoogle(response)}
                                                        >
                                                            <img
                                                                src={imageGoogle}
                                                                style={{ width: '30px', cursor: 'pointer' }}
                                                                alt="vk icon"
                                                            />
                                                        </GoogleLogin> */}
                                                        <a>
                                                            <img
                                                                src={imageVk}
                                                                style={{ width: '30px', marginRight: '5px', cursor: 'pointer' }}
                                                                alt="vk icon"
                                                                onClick={() => isFetching ? false : this.handleVK()}
                                                            />
                                                        </a>
              
                                                    </div>

                                                    <Link to="/forgot">Забыли пароль?</Link>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
    state => ({
        ...state.auth
    })
)(SignIn);


// WEBPACK FOOTER //
// ./src/components/SignIn/index.js